import { action, makeObservable, observable, reaction } from 'mobx';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { DECISION_RESULT_EVENTS } from '../enums/decisionTypes';
import { DECISION_ACTION_TYPES } from '../enums/betTypes';

class GameStore {
  isBetsClosed = false;

  decisionDuration = null;

  betId = null;

  splitBetId = null;

  hasInsurance = false;

  isShowDecision = null;

  possibleBetActions = null;

  isSelectedDecision = false;

  decisionActionsCount = null;

  liveDecisionActionCounts = null;

  partnerHasSurrenderAction = false;

  gameTypes = [];

  toggleInsuranceAnimatedCard = false;

  toggleTimer = false;

  constructor() {
    makeObservable(this, {
      toggleTimer: observable,
      betId: observable,
      splitBetId: observable,
      hasInsurance: observable,
      isBetsClosed: observable,
      isShowDecision: observable,
      decisionDuration: observable,
      isSelectedDecision: observable,
      partnerHasSurrenderAction: observable,
      toggleInsuranceAnimatedCard: observable,
      possibleBetActions: observable.deep,
      decisionActionsCount: observable.deep,
      liveDecisionActionCounts: observable.deep,
      setBetId: action.bound,
      setSplitBetId: action.bound,
      setHasInsurance: action.bound,
      setIsBetsClosed: action.bound,
      setIsShowDecision: action.bound,
      setDecisionDuration: action.bound,
      setIsSelectedDecision: action.bound,
      setPossibleBetActions: action.bound,
      setDecisionActionsCount: action.bound,
      setPartnerHasSurrenderAction: action.bound,
      setLiveDecisionActionCounts: action.bound,
      setGameTypes: action.bound,
      resetGameStore: action.bound,
      setToggleInsuranceAnimatedCard: action.bound,
      setToggleTimer: action.bound,
    });

    reaction(
      () => this.isBetsClosed,
      (value) => {
        popupStore.setReloadFrameForUnderMaintenanceOnRoundStart(!value);
      }
    );
  }

  setBetId(betId) {
    this.betId = betId;
  }

  setSplitBetId(splitBetId) {
    this.splitBetId = splitBetId;
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setDecisionDuration(second) {
    this.decisionDuration = second;
  }

  setPossibleBetActions(actions) {
    this.possibleBetActions = actions;
  }

  setToggleInsuranceAnimatedCard = () => {
    this.toggleInsuranceAnimatedCard = true;

    setTimeout(() => {
      this.toggleInsuranceAnimatedCard = false;
    }, 1000);
  };

  setLiveDecisionActionCounts(eventName) {
    if (!eventName) {
      this.liveDecisionActionCounts = null;
      return;
    }
    if (DECISION_RESULT_EVENTS.HitResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Hit]: this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Hit]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Hit] || 0) + 1
          : 1,
      };
    }
    if (DECISION_RESULT_EVENTS.StandResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Stand]: this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Stand]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Stand] || 0) + 1
          : 1,
      };
    }
    if (DECISION_RESULT_EVENTS.DoubleResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Double]: this.liveDecisionActionCounts?.[
          DECISION_ACTION_TYPES.Double
        ]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Double] || 0) + 1
          : 1,
      };
    }
    if (DECISION_RESULT_EVENTS.SplitResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Split]: this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Split]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Split] || 0) + 1
          : 1,
      };
    }
    if (DECISION_RESULT_EVENTS.SurrenderResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Surrender]: this.liveDecisionActionCounts?.[
          DECISION_ACTION_TYPES.Surrender
        ]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Surrender] || 0) + 1
          : 1,
      };
    }
    if (DECISION_RESULT_EVENTS.InsuranceBetResult === eventName) {
      this.liveDecisionActionCounts = {
        ...this.liveDecisionActionCounts,
        [DECISION_ACTION_TYPES.Insurance]: this.liveDecisionActionCounts?.[
          DECISION_ACTION_TYPES.Insurance
        ]
          ? (this.liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Insurance] || 0) + 1
          : 1,
      };
    }
  }

  setDecisionActionsCount(decisions) {
    if (decisions?.length) {
      this.decisionActionsCount = decisions.reduce((acc, cur) => {
        acc[cur.action] = cur.count;
        return acc;
      }, {});
    } else {
      this.decisionActionsCount = null;
    }
  }

  setIsShowDecision(bool) {
    this.isShowDecision = bool;
  }

  setHasInsurance(bool) {
    this.hasInsurance = bool;
  }

  setIsSelectedDecision(bool) {
    this.isSelectedDecision = bool;
  }

  setToggleTimer(bool) {
    this.toggleTimer = bool;
  }

  setPartnerHasSurrenderAction(bool) {
    this.partnerHasSurrenderAction = bool;
  }

  setGameTypes(arg) {
    this.gameTypes = arg;
  }

  resetGameStore() {
    this.isBetsClosed = false;
    this.decisionDuration = null;
    this.betId = null;
    this.splitBetId = null;
    this.hasInsurance = false;
    this.isShowDecision = null;
    this.possibleBetActions = null;
    this.isSelectedDecision = false;
    this.decisionActionsCount = null;
    this.liveDecisionActionCounts = null;
    this.partnerHasSurrenderAction = false;
    this.gameTypes = [];
    this.toggleInsuranceAnimatedCard = false;
    this.toggleTimer = false;
  }
}

export const gameStore = new GameStore();
